const ACCEPTED_COOKIES = "acceptedCookies";

export default {
  ACCEPTED_COOKIES,
};
